export const iconFeatures = [
    {
        iconClass: "icon-shipping",
        title: "Free Shipping",
        description: "Enjoy free shipping on all orders",
    },
    {
        iconClass: "icon-return",
        title: "Free Returns",
        description: "Within 14 days for a return",
    },
    {
        iconClass: "icon-support",
        title: "Support Online",
        description: "We support customers service",
    },
];



export const features = [
    {
        imgSrc: "/images/section/icon-quality.svg",
        bgClass: "bg-light-purple-10",
        title: "Quality Products",
        description: "Only the freshest ingredients for your table.",
        wowDelay: "0s",
    },
    {
        imgSrc: "/images/section/icon-shop.svg",
        bgClass: "bg-light-blue-4",
        title: "Convenient Shopping",
        description: "Easy and quick delivery straight to your door.",
        wowDelay: ".1s",
    },
    {
        imgSrc: "/images/section/icon-prices.svg",
        bgClass: "bg-pink-4",
        title: "Affordable Prices",
        description: "Great value on all your daily essentials.",
        wowDelay: ".2s",
    },
];

